import React, { useState } from "react";
import TextField from "./TextField";
import { Question } from "../types";
import { deleteSurveyQuestion, writeRandomSentencesToShortResponseResults } from "../Firebase/utils";
import { deleteQuestion } from "../store/features/CreateSurveySlice";
import { useAppDispatch, useAppSelector } from "../store/store";
import ShortResponseForm from "./ShortResponseForm";
import QuestionPreviewContainer from "./QuestionPreviewContainer";
import useDeleteSurveyQuestion from "../CustomHooks/useDeleteSureveyQuestion";

interface MultipleSelectionOptionsPreviewDisplayProps {
    question: Question;
    questionText: string;
    options: string[];
}

export default (props: MultipleSelectionOptionsPreviewDisplayProps) => {

    const { question, questionText, options } = props;
    const dispatch = useAppDispatch();
    const user = useAppSelector(state => state.user.user);
    const survey = useAppSelector(state => state.survey.survey);
    const [ modalOpen, setModalOpen ] = useState<boolean>(false);
    
    const { deleteQuestion, loading, error } = useDeleteSurveyQuestion(survey, question);

    const handleEditQuestion = () => {
        writeRandomSentencesToShortResponseResults(survey.id, question);
        setModalOpen(true);
        // try{
        //     updateSurveyQuestion(user, survey, question);
        //     dispatch(updateQuestion(question));
        // }catch(err){
        //     console.error(err);
        // }        
    }

    return (
        <QuestionPreviewContainer question={question} handleDeleteQuestion={() => deleteQuestion()} handleEditQuestion={handleEditQuestion}>
            <div className="flex flex-col gap-4">
                <TextField placeholder="Enter your Response" inputValue={''} setInputValue={() => {}} styles='w-full md:w-11/12'/>
                {options.map((option: string) => {
                    return (
                        <div className="flex gap-5" key={option}>
                            <p>{option}</p>
                        </div>
                    );
                })}
            </div>
            <ShortResponseForm openState={modalOpen} onClose={() => setModalOpen(false)} question={question}/>
        </QuestionPreviewContainer>
    )
}